import React from "react";

type Status = "pending" | "error" | "success";
type HandlerKeys = Status | "default";
export type PromiseResult<T> = T | Error;

export class ReactUtils {
  static getComponentName(element: React.ReactElement) {
    const node = element as React.ReactElement<React.ComponentType>;
    const type = (
      node as unknown as React.ReactElement<React.FunctionComponent>
    ).type;
    return typeof type === "function"
      ? (type as React.FunctionComponent).displayName ||
          (type as React.FunctionComponent).name ||
          "Unknown"
      : typeof type === "object"
        ? (type as React.FunctionComponent).displayName || "Unknown"
        : type.toString();
  }
  static createSuspender<T>(promise: Promise<T>) {
    let status: Status = "pending";
    let response: PromiseResult<T>;

    const suspender = promise.then(
      (res: T) => {
        status = "success";
        response = res;
      },
      (err: Error) => {
        status = "error";
        response = err;
      },
    );

    const handler: Record<HandlerKeys, () => PromiseResult<T>> = {
      pending: () => {
        throw suspender;
      },
      error: () => {
        throw response;
      },
      success: () => response,
      default: () => response,
    };

    const read = (): PromiseResult<T> => {
      const operation = handler[status] || handler.default;
      return operation();
    };

    return { read };
  }
  static hardRedirect(path: string) {
    window.location.href = `${window.location.origin}${path}`;
  }
}
